<template>
  <div style="width:100%;">
    <table>
      <tr>
        <th></th>
        <th>Name</th>
      </tr>
      <tr v-for="user in users" :key="user.id">
        <td @click="goUserDetail(user)"><i class="material-icons">account_circle</i></td>
        <td>{{user.name}}</td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'user-profiles',
  data () {
    return {
      users: []
    }
  },
  methods: {
    goUserDetail (user) {
      this.$router.push({name: 'admin-user-detail', params: {user: user, current_user: true}})
    },
  },
  beforeMount() {
      this.$store.dispatch('getUsers', {}).then(() => {
          this.users = this.$store.getters.getUsers
        }).catch(error => {
          this.showError(error)
        })
  },
}
</script>

<style scoped>
  table {
    font-family: arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
  }

  td, th {
    border: 1px solid #dddddd;
    text-align: left;
    padding: 8px;
  }

  tr:nth-child(even) {
    background-color: #dddddd;
  }
</style>
